// Voucher tích lũy "Càng mua càng rẻ": mỗi mốc số lượng giảm theo % hoặc số tiền (đ).
import { DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';

export const parseCumulativeTiers = (value) => {
  let parsed = value;
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed || '[]');
    } catch (error) {
      return [];
    }
  }
  return Array.isArray(parsed) ? parsed : [];
};

// Mốc cũ chưa có cumulativeType → coi là % (hành vi trước đây)
export const getCumulativeType = (tier) =>
  Number(tier && tier.cumulativeType) === DISCOUNT_AMOUNT_TYPE.MONEY
    ? DISCOUNT_AMOUNT_TYPE.MONEY
    : DISCOUNT_AMOUNT_TYPE.PERCENT;

export const findCumulativeTier = (cumluativeValues, totalQuantity) =>
  parseCumulativeTiers(cumluativeValues).find(
    (tier) =>
      Number(tier.quantityFrom) <= totalQuantity &&
      totalQuantity <= Number(tier.quantityTo),
  ) || null;

// Tiền giảm trên 1 sản phẩm, làm tròn xuống, không vượt giá sản phẩm
export const calcCumulativeUnitDiscount = (tier, price) => {
  if (!tier) return 0;
  const unitPrice = Number(price) || 0;
  const value = Number(tier.cumulativeValue) || 0;
  const discount =
    getCumulativeType(tier) === DISCOUNT_AMOUNT_TYPE.MONEY
      ? value
      : (unitPrice * value) / 100;
  return Math.max(0, Math.min(Math.floor(discount), unitPrice));
};

export const formatCumulativeValue = (tier, formatMoney) =>
  getCumulativeType(tier) === DISCOUNT_AMOUNT_TYPE.MONEY
    ? `${formatMoney(tier.cumulativeValue)}đ`
    : `${tier.cumulativeValue}%`;
